export default __webpack_public_path__ + "static/media/Ted.bdbf42f4.jpg";